import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer.jsx";
import TypebotFrame from "../components/general/TypebotFrame.jsx";

const ExerciceMiParcoursRenforcementBureautique = () => {
  return (
    <section>
      <Nav />
      <div style={{ width: "100%", minHeight: "600px" }}>
        <TypebotFrame slug="exercice-mi-parcours-renforcement-bureautique-excel-power-point-word-vwfmcmr"/>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default ExerciceMiParcoursRenforcementBureautique;